<template>
  <div class="Homepage">
    <ShowSliderComponent :offers="offers" :loading="loading" />
    <BabillardComponent />
  </div>
</template>

<script lang="ts" setup>
import httpClient from '@/Api/HttpClient';
import BabillardComponent from '@/components/home/BabillardComponent.vue';
import ShowSliderComponent from "@/components/home/ShowSliderComponent.vue";
import { AxiosResponse } from 'axios';
import { onMounted, ref } from 'vue';

interface Offer {
  id: number;
  title: string;
  count: number;
  image: string;
  showId: number;
  createdAt: string;
  updatedAt: string;
}

const loading = ref(true);
const offers = ref<Offer[]>([]);

onMounted(() => {
  httpClient
    .get('/portal/most-clicked-offers')
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        offers.value = response.data.result;
      }
    })
    .catch((e: any) => {})
    .finally(() => {
      loading.value = false;
    });
});
</script>
